<template>
    <div class="left">
      <div class="page-content any-page">
        <SectionContent :content="content" />
      </div>
    </div>
</template>

<script>
import Content from '../../components/Content.vue'
import completeLoad from '../../mixins/completeLoad'
import { SET_COLOR_SIDEBAR } from '../../store'
import SectionContent from '../../components/Sections/SectionContent.vue'

export default {
  props: [
    'data',
  ],

  mixins: [completeLoad],

  components: {
    Content
  },

  components: {
    SectionContent
  },

  computed: {
    content () {
      let html = ''

      for(let i in this.data) {
        if (this.data[i].command === 'insert') {
          html = this.data[i].data
        }
      }

      return  {
        html: html
      }
    }
  }
}
</script>
